import "./ProductCard.css"

export interface IProductCardProps {
  date: string
  discount: number
  title: string
  isPast?: boolean
  showDiscountPreview: boolean
  goToId?: string
}

const ProductCard = ({
  date,
  discount,
  title,
  isPast = false,
  showDiscountPreview = true,
  goToId
}: IProductCardProps) => {
  return (
    <div className={`bf-product-card ${isPast && `bf-product-card-disabled`}`}>
      <p className="bf-product-card-date">{date}</p>
      <div className="bf-product-card-wrapper">
        <div className="bf-product-card-content">
          <h3 className="bf-product-card-title" dangerouslySetInnerHTML={{ __html: title }} />

          {showDiscountPreview ? (
            <div
              className={`bf-product-card-discount ${
                discount === 15 && `bf-product-card-discount-prominent`
              }`}
            >
              <p className="bf-product-card-percentage">{discount}%</p>
              <p className="bf-product-card-text">descuento</p>
            </div>
          ) : null}
        </div>
        {goToId && isPast ? (
          <a href={`#${goToId}`} className="bf-product-card-link">
            Quiero esta oferta
          </a>
        ) : null}
      </div>
    </div>
  )
}

export default ProductCard
